import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-field',
    template: `
    <div class="fieldContiner">
        <label class="form-control-label control-label">
            {{to.label}}
            <span *ngIf="to.required && !to.hideRequiredMarker" class="required-symbol error">*</span>
        </label>
        <ng-container #fieldComponent>
        </ng-container>
    </div>
    <div class="fieldContiner" *ngIf="showError">
        <div *ngIf="showError" class="error-wrapper" style="grid-column-start:2;">
            <i class="icon-error" role="presentation"></i>
            <formly-validation-message [field]="field"></formly-validation-message>
        </div>
    </div>
  `,
    styles: [`
    .fieldContiner{
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin-top: 10px;
    }
  `]
})
export class FieldWrapperComponent extends FieldWrapper {
    @ViewChild('fieldComponent', { read: ViewContainerRef, static: true })
    fieldComponent!: ViewContainerRef;
}